import PhoneInput from "react-phone-input-2";
import useTranslator from "../../../hooks/useTranslator";
import { useContext, useState } from "react";
import * as Joi from "joi-browser";
import { haveValue } from "../../../helper/common";
import LandLordContext from "../../../context/landlord/LandLordContext";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { MdFileUpload } from "react-icons/md";
import { Row, Col, Modal } from "react-bootstrap";
import { init } from "onfido-sdk-ui";
import axiosInstance from "../../../services/authWrapper";
import AuthContext from "../../../context/auth/AuthContext";
import TenantContext from "../../../context/tenant/TenantContext";

const AddForm = () => {
  const llCreated = true;
  const { createTenant } = useContext(LandLordContext);
  const { setLoading } = useContext(AuthContext);
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const defaultVals = {
    fname: "",
    lname: "",
    doc_type: "dni_nie",
    dni_nie: "",
    passport_id: "",
    dob: "",
    post_code: "",
    email: "",
    phone_number: "",
  };
  const schema = {
    fname: Joi.string().min(1).label("First Name"),
    lname: Joi.string().min(1).label("Last Name"),
    doc_type: Joi.string().min(1).label("doc_type"),
    dni_nie: Joi.string().allow("").label("Dni/Nie").optional(),
    passport_id: Joi.string().allow("").label("Passport Id").optional(),
    dob: Joi.string().min(1).label("Date Of Birth"),
    post_code: Joi.string().min(1).label("Post Code"),
    email: Joi.string().email().min(1).label("Email"),
    phone_number: Joi.string().min(1).label("Phone Number"),
  };

  const { onfidoKyc } = useContext(TenantContext);

  const [formData, setFormData] = useState(defaultVals);
  const [hasError, setHasError] = useState(false);
  const [showVerify, setShowVerify] = useState(false);
  const [user, setUser] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    setHasError(false);
  };

  const handlePhoneChange = (val) => {
    setFormData((prevData) => ({ ...prevData, phone_number: val }));
    setHasError(false);
  };

  const handleSubmitForm = () => {
    const { error } = Joi.validate(formData, schema, {
      abortEarly: false,
    });
    console.log(error);
    if (
      error ||
      (!haveValue(formData?.passport_id) && !haveValue(formData?.dni_nie))
    ) {
      setHasError(true);
      return;
    } else {
      createTenant(formData)
        .then((res) => {
          toast.success(_t("tenantCreated"));
          setUser(res.data);
          setShowVerify(true);
          // navigate("/created-tenant");
        })
        .catch((err) => {
          console.log(err);
          toast.error(_t("somethingWentWrong"));
        });
    }
  };

  const handleNavigateHome = () => {
    navigate("/created-tenant");
  };

  const initiateOnfido = () => {
    setLoading(true);
    axiosInstance
      .get(
        `${process.env.REACT_APP_SERVER_URL}/tenants/kyc/${user?._id}${
          llCreated ? "?llCreated=true" : ""
        }`
      )
      .then((res) => {
        //console.log("ONFIDO WITH WORKFLOW= ", res.data);

        initiateKyc(res.data.sdk_data.token, res.data.workflow_data.id);
        setShowVerify(false);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        //console.log("Error Onfido = ", err);
      });
  };

  const initiateKyc = (token, workFlowRunId) => {
    //console.log("On Fido Token = ", token);

    let onfido = {};

    onfido = init({
      token: token,
      useModal: true,
      isModalOpen: true,
      language: localStorage.getItem("i18nextLng") == "es" ? "es" : "en_US",
      containerId: "onfido-mount",
      workflowRunId: `${workFlowRunId}`,
      onComplete: function (data) {
        console.log("everything is complete");

        saveOnfidoKycResponse(data);
      },
      onError: function (err) {},
      onUserExit: function (userExitCode) {
        // navigate('/created-tenants')
        console.log("user exitted", userExitCode);
        setShowVerify(true);
      },
      onModalRequestClose: function () {
        // Update options with the state of the modal
        onfido.setOptions({ isModalOpen: false });
        setShowVerify(true);
        console.log("modal closed of onfido");
      },
      //steps: ['welcome', 'poa', 'document', 'face', 'complete'],  //poa-proof of address
      steps: ["welcome", "document", "face", "complete"],
    });
  };

  const saveOnfidoKycResponse = (kycData) => {
    onfidoKyc(user?._id, kycData, "?llCreated=true")
      .then((res) => {
        navigate("/created-tenant");
      })
      .catch((err) => {});
  };

  return (
    <>
      <div id="onfido-mount"></div>
      <div className="Property-wrapper property-add-form">
        <h1 className="step-name">
          {_t(
            "verifyIdAndDefaultHeading",
            "Heading when LL is adding a new TT in form"
          )}
        </h1>
        <div className="auth-form mt-0">
          <div className="landloard-address-form">
            <div className="custom-mt">
              <Row>
                <Col xl={6}>
                  <div className="forminput ">
                    <label htmlFor="" className="percentage_salary_p ">
                      {_t("firstName")}*
                    </label>
                    <input
                      className="form-control "
                      type="text"
                      value={formData?.fname}
                      placeholder={_t("enterFirstName")}
                      name="fname"
                      onChange={handleInputChange}
                    />
                  </div>
                </Col>
                <Col xl={6}>
                  <div className="forminput ">
                    <label htmlFor="" className="percentage_salary_p ">
                      {_t("lastName")}*
                    </label>
                    <input
                      className="form-control "
                      type="text"
                      value={formData?.lname}
                      name="lname"
                      onChange={handleInputChange}
                      placeholder={_t("enterLastName")}
                    />
                  </div>
                </Col>
                <Col xl={6}>
                  <div className="forminput ">
                    <label htmlFor="" className="percentage_salary_p ">
                      {_t("dateOfBirth", "LL is adding a new TT form")}*
                    </label>
                    <input
                      className="form-control "
                      name="dob"
                      onChange={handleInputChange}
                      type="date"
                      value={formData?.dob}
                      placeholder={`${_t("select")} ${_t("dateOfBirth")}`}
                    />
                  </div>
                </Col>
                <Col xl={6}>
                  <div className="forminput ">
                    <label htmlFor="" className="percentage_salary_p ">
                      {_t("postcode")}*
                    </label>
                    <input
                      className="form-control "
                      name="post_code"
                      onChange={handleInputChange}
                      type="text"
                      value={formData?.post_code}
                      placeholder={`${_t("enter")} ${_t("postcode")}`}
                    />
                  </div>
                </Col>
                <Col xl={6}>
                  <div className="forminput ">
                    <label htmlFor="" className="percentage_salary_p ">
                      {_t("email")}*
                    </label>
                    <input
                      className="form-control "
                      name="email"
                      onChange={handleInputChange}
                      type="email"
                      value={formData?.email}
                      placeholder={`${_t("enter")} ${_t("email")}`}
                    />
                  </div>
                </Col>
                <Col xl={6}>
                  <div className="forminput ">
                    <label htmlFor="" className="percentage_salary_p ">
                      {_t("phoneNumber")}*
                    </label>
                    <PhoneInput
                      onChange={handlePhoneChange}
                      className="phone_input"
                      value={formData?.phone_number}
                      international
                      country={"es"}
                    />
                  </div>
                </Col>
                <Col xl={12}>
                  <div className="forminput ">
                    <label htmlFor="" className="percentage_salary_p ">
                      {_t("chooseIdType", "LL is adding a new TT form")}*
                    </label>
                    <div className="d-flex gap-5">
                      <label htmlFor="" className="percentage_salary_p ">
                        <input
                          className="me-2 form-check-input"
                          type="radio"
                          checked={formData?.doc_type == "dni_nie"}
                          value={"dni_nie"}
                          name="doc_type"
                          onChange={handleInputChange}
                        />
                        <span>{_t("dniNie")}</span>
                      </label>
                      <label htmlFor="" className="percentage_salary_p ">
                        <input
                          className="me-2 form-check-input"
                          type="radio"
                          checked={formData?.doc_type == "passport_id"}
                          name="doc_type"
                          onChange={handleInputChange}
                          value={"passport_id"}
                        />
                        <span>{_t("passport")}</span>
                      </label>
                    </div>
                  </div>
                </Col>
                <Col xl={12}>
                  <div>
                    {formData?.doc_type == "dni_nie" ? (
                      <>
                        <div className="forminput ">
                          <label htmlFor="" className="percentage_salary_p ">
                            {_t("dniNie")}*
                          </label>
                          <input
                            className="form-control "
                            name="dni_nie"
                            onChange={handleInputChange}
                            type="text"
                            value={formData?.dni_nie}
                            placeholder={_t("enterValue")}
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="forminput ">
                          <label htmlFor="" className="percentage_salary_p ">
                            {_t("passport")}*
                          </label>
                          <input
                            className="form-control "
                            name="passport_id"
                            onChange={handleInputChange}
                            type="text"
                            value={formData?.passport_id}
                            placeholder={_t("enterValue")}
                          />
                        </div>
                      </>
                    )}
                  </div>
                </Col>
              </Row>
              {hasError && (
                <label className="forminput password_error">
                  {_t("allFieldsAreRequired")}
                </label>
              )}
              {/* <button className="upload-btn-custom-design">
                <MdFileUpload />
                {_t("uploadId")}
              </button> */}
              <button onClick={handleSubmitForm} className="btn btngreen w-100">
                {_t("submit")}
              </button>
            </div>
          </div>
        </div>
      </div>
      <Modal show={showVerify} centered className="newmodalui">
        <Modal.Header>
          <Modal.Title>
            <h4>
              {_t(
                "doYouWantToVerifyDocument",
                "On LL side while completing TT profile"
              )}
            </h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-center gap-4 pt-4">
            <button
              name="protected_housing"
              value="false"
              className={`btn w-100 btnoutline`}
              onClick={handleNavigateHome}
            >
              {_t(
                "contiueWithoutVerifyingId",
                "On LL side while completing TT profile"
              )}
            </button>
            <button
              name="protected_housing"
              value="true"
              className={`btn w-100 btnorange`}
              onClick={initiateOnfido}
            >
              {_t(
                "continueVerifyingDocuments",
                "On LL side while completing TT profile"
              )}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddForm;
